import styled from 'styled-components';
import { Alert } from 'antd';
import { CopyOutlined } from '@ant-design/icons';

export const StyledHtsAlert = styled(Alert)`
  margin-bottom: ${({ theme }) => theme.spacing.space_4};
  margin-top: ${({ theme }) => theme.spacing.space_3};
  border-radius: ${({ theme }) => theme.spacing.space_2};
  max-width: 650px;
`;

export const DrawerAlert = styled(Alert)`
  margin-bottom: 24px;
`;

export const QuestionBlock = styled.div<{ $dimmed?: boolean }>`
  margin-bottom: 24px;
  opacity: ${({ $dimmed }) => ($dimmed ? 0.6 : 1)};
`;

export const QuestionText = styled.div`
  margin-bottom: ${({ theme }) => theme.spacing.space_3};
`;

export const CopyIcon = styled(CopyOutlined)`
  margin-left: 6px;
  cursor: pointer;
`;

export const RecommendationMessageWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const RecommendationRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: ${({ theme }) => theme.spacing.space_4};
`;

export const PromptMessageWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  flex-wrap: wrap;
`;

export const PromptText = styled.span`
  flex: 1;
  min-width: 200px;
`;

export const ReasoningContent = styled.div`
  margin-top: ${({ theme }) => theme.spacing.space_1};
`;
